let tooltipsAttr = 'data-tippy-content';
let $closeBtns = $('.js-tippy-close');

addHandlers();
initTippy();

function initTippy() {
	
	var $tippyElements = $('[' + tooltipsAttr + ']');
	
	$tippyElements.each(function (i, el) {
		
		var $tippyElement = $(el);
		
		var poperModifiers = [];
		
		if ($tippyElement.data('same-width')) {
			poperModifiers = setSameWidth(poperModifiers);
		} else {
			poperModifiers.push(
			  {
				  name: 'preventOverflow',
				  options: {
					  padding: {
						  left: 30,
						  right: 30,
					  },
				  },
			  }
			);
		}
		
		tippy([$tippyElement[0]], {
			// hideOnClick: 'toggle', // debug mode
			// interactive: true,
			// trigger: 'click',
			theme: 'main',
			allowHTML: true,
			zIndex: 99999, // чтобы подсказка была поверх fancybox
			maxWidth: 'none',
			appendTo: document.body,
			placement: 'bottom',
			touch: getTouchOption($tippyElement),
			popperOptions: {
				modifiers: poperModifiers,
			},
			onShow: function (instance) {
				// Одновременный показ только одной подсказки
				tippy.hideAll();
				
			},
			onMount: function (instance) {
				initScrollBar(instance);
			},
			onCreate: function (instance) {
				// dynamicTopPadding(instance, poperModifiers);
			},
			onTrigger: function (instance) {
				cutomTrigger($tippyElement);
			},
		});
		
	})
	
	setContentFromDom();
	
}

function cutomTrigger($tippyElement) {
	$tippyElement.trigger('tippy:show');
}

function getTouchOption($tippyElement) {
	
	let touchOption = ['hold', 500];
	
	if(!$tippyElement.attr('data-tippy-click')) {
		touchOption = true;
	}
	
	return touchOption;
	
}

function initScrollBar(instance) {
	
	let $scrollBarEl = $('.tippy-box').find('.js-tippy-box--simplebar');
	
	if($scrollBarEl.length === 1) {
		new SimpleBar($scrollBarEl[0]);
	}
	
}

// Делаем подсказку такой же ширины как и сам элемент
function setSameWidth(poperModifiers) {
	
	poperModifiers.push(
	  {
		  name: "sameWidth",
		  enabled: true,
		  fn: function (op) {
			  op.state.styles.popper.width = op.state.rects.reference.width + 'px';
		  },
		  phase: "beforeWrite",
		  requires: ["computeStyles"],
		  effect: function (op) {
			  op.state.elements.popper.style.width = op.state.elements.reference.clientWidth + 'px';
		  },
	  }
	);
	
	return poperModifiers;
	
}

function setContentFromDom() {
	
	var $tippyElements = $('[' + tooltipsAttr + ']');
	
	$tippyElements.each(function (i, el) {
		
		var $el = $(el);
		var content = $el.attr(tooltipsAttr);
		
		// если передан class или id, то подставляем элемент по этому селектору
		if (content.indexOf('.') === 0 || content.indexOf('#') === 0) {
			
			var $contentEl = $(content);
			
			// включаем отображение изначально скрытых элементов
			$contentEl.css('display', '');
			
			var instance = $el[0]._tippy;
			
			instance.setContent($contentEl[0]);
		}
		
		
	})
	
}

function addHandlers() {
	$closeBtns.click(function () {
		tippy.hideAll();
	});
}

// Компенсация фиксированного хедера
function dynamicTopPadding(instance, poperModifiers) {
	
	var $header = $('');
	
	$header.on('open.header', function () {
		
		var headerIsFixed = ($header.css('position') === 'fixed');
		
		if (headerIsFixed) {
			updatePadding(instance, $header.height());
		}
		
	});
	
	$header.on('close.header', function () {
		
		var headerIsFixed = ($header.css('position') === 'fixed');
		
		if (!headerIsFixed) {
			updatePadding(instance, 0);
		}
		
	});
	
	
	$(window).resize(onResize);
	
	function onResize() {
		
		updatePadding(instance, $header.height());
		
	}
	
	
	function updatePadding(instance, viewportPaddingTop) {
		
		var flipModifier = {
			name: 'flip',
			options: {
				'padding': {
					'top': viewportPaddingTop,
				}
			},
		};
		
		var resPoperModifiers = poperModifiers.concat(flipModifier);
		
		instance.setProps({
			popperOptions: {
				modifiers: resPoperModifiers,
			},
		});
		
	}
	
}